<div class="modal-header">
  <h5 class="modal-title">Tire Size Calculator</h5>
  <button type="button" class="btn-close btn-close-white" (click)="close()"  aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="form-group row mb-3">
    <div class="col">
      <label for="tireSize" class="form-label">Top Speed</label>
      <a href="#" class="btn-link mx-3"
         [popoverTitle]="helpText['topSpeed'].title"
         [ngbPopover]="helpText['topSpeed'].text">
        <i class="fa-solid fa-circle-question"></i>
      </a>
      <input type="number" class="form-control" id="topSpeed" name="topSpeed" placeholder="KMH"
             [(ngModel)]="topSpeed"
             (keyup)="calculateTireSize()" />
    </div>
  </div>
  <div class="form-group row mb-3">
    <div class="col">
      <label for="tireSize" class="form-label">Engine RPM</label>
      <a href="#" class="btn-link mx-3"
         [popoverTitle]="helpText['engineRPM'].title"
         [ngbPopover]="helpText['engineRPM'].text">
        <i class="fa-solid fa-circle-question"></i>
      </a>
      <input type="number" class="form-control" id="engineRpm" name="engineRPM" placeholder="RPM"
             [(ngModel)]="engineRPM"
             (keyup)="calculateTireSize()" />
    </div>
  </div>
  <div class="form-group row mb-3">
    <div class="col">
      <label for="tireSize" class="form-label">Final Gear Ratio</label>
      <a href="#" class="btn-link mx-3"
         [popoverTitle]="helpText['finalGearRatio'].title"
         [ngbPopover]="helpText['finalGearRatio'].text">
        <i class="fa-solid fa-circle-question"></i>
      </a>
      <input type="number" class="form-control" id="finalGearRatio" name="finalGearRatio" placeholder=""
             [(ngModel)]="finalGearRatio"
             (keyup)="calculateTireSize()" />
    </div>
  </div>
  <div class="form-group row mb-4">
    <div class="col">
      <label for="tireSize" class="form-label">Top Gear Ratio</label>
      <a href="#" class="btn-link mx-3"
         [popoverTitle]="helpText['topGearRatio'].title"
         [ngbPopover]="helpText['topGearRatio'].text">
        <i class="fa-solid fa-circle-question"></i>
      </a>
      <input type="number" class="form-control" id="topGearRatio" name="topGearRatio" placeholder=""
             [(ngModel)]="topGearRatio"
             (keyup)="calculateTireSize()" />
    </div>
  </div>

  <div class="row">
    <div class="row">
      <div class="col-6 h1">
        Tire Size
      </div>
      <div class="col-6 display-6" [hidden]="!tireSize">
        {{tireSize}} {{userPreferences?.lengthUnits.display}}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="reset()">Reset</button>
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  <button type="button" class="btn btn-primary" (click)="ok()" [disabled]="!tireSize">Ok</button>
</div>

